export function JoinClassName(...classNameList: string[]) {
  return classNameList.join(' ')
}
